export function validateReplacementPassword(
  password: string,
  confirmation: string,
): string | null {
  if (password.length < 8) {
    return "A nova senha deve ter pelo menos 8 caracteres.";
  }
  if (password !== confirmation) {
    return "A confirmação não corresponde à nova senha.";
  }
  return null;
}

/** Only in-app destinations are accepted, including after percent decoding. */
export function safeReturnTo(value: unknown): string {
  if (typeof value !== "string") return "/app";
  try {
    const decoded = decodeURIComponent(value);
    if (
      decoded.includes("\\") ||
      [...decoded].some((char) => char.charCodeAt(0) < 32) ||
      !/^\/(app(?:[/?#]|$)|help(?:[/?#]|$))/.test(decoded)
    )
      return "/app";
    const url = new URL(value, "https://local.invalid");
    return url.origin === "https://local.invalid" &&
      /^\/(app(?:[/?#]|$)|help(?:[/?#]|$))/.test(url.pathname)
      ? `${url.pathname}${url.search}${url.hash}`
      : "/app";
  } catch {
    return "/app";
  }
}
